/**
 * Shared Crown-badge sprite-sheet data + the ordered frame list driving the
 * animated ◈ Crown Dollars badge. Hoisted here because the same derivation
 * (sort the sheet's frames by their `frame_N.png` index, then map to the frame
 * rects) was copy-pasted across the crown button, the balance pill, the offer
 * tier, and the deposit form. One module keeps the playback identical
 * everywhere and avoids re-parsing the sheet per call site.
 */
import crownBadgeSheet from '@/assets/spritesheets/crown-badge.png';
import crownBadgeJson from '@/assets/spritesheets/crown-badge.json';
import { type CrownBadgeData } from '@/components/ui/crown-button/types';

export const crownBadgeData = crownBadgeJson as CrownBadgeData;

/** Frame rects, ordered by the sheet's `frame_N.png` index, for `SpriteSheetPlayer`. */
export const crownFrames = Object.entries(crownBadgeData.frames)
  .sort(([a], [b]) => {
    const frameA = Number.parseInt(a.replace('frame_', '').replace('.png', ''), 10);
    const frameB = Number.parseInt(b.replace('frame_', '').replace('.png', ''), 10);
    return frameA - frameB;
  })
  .map(([, frameData]) => frameData.frame);

export { crownBadgeSheet };
